/* eslint-disable max-len */
import React from 'react'
import { createIcon } from '@chakra-ui/icon'

const LeftArrow = createIcon({
    viewBox: '0 0 12 10',
    displayName: 'LeftArrow',
    path: (
        <path fillRule="evenodd" clipRule="evenodd" d="M5.31042 1.10967C5.51871 0.901397 5.51871 0.563712 5.31042 0.355435C5.10215 0.147147 4.76446 0.147147 4.55618 0.355435L0.289517 4.6221C0.0812288 4.83038 0.0812288 5.16806 0.289517 5.37634L4.55618 9.64306C4.76446 9.85128 5.10215 9.85128 5.31042 9.64306C5.51871 9.43474 5.51871 9.09704 5.31042 8.88872L1.42089 4.99922L5.31042 1.10967ZM11.7105 1.10967C11.9187 0.901397 11.9187 0.563712 11.7105 0.355435C11.5022 0.147147 11.1645 0.147147 10.9561 0.355435L6.68952 4.6221C6.48123 4.83038 6.48123 5.16806 6.68952 5.37634L10.9561 9.64306C11.1645 9.85128 11.5022 9.85128 11.7105 9.64306C11.9187 9.43474 11.9187 9.09704 11.7105 8.88872L7.82089 4.99922L11.7105 1.10967Z" fill="white" />
    ),
})

export default LeftArrow